/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_FooterInputs */

const en_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade, downgrade or cancel any time.`)
};

const id_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa upgrade, downgrade, atau cancel kapan saja.`)
};

/**
* | output |
* | --- |
* | "Upgrade, downgrade or cancel any time." |
*
* @param {Pricing_FooterInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_footer = /** @type {((inputs?: Pricing_FooterInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_FooterInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_footer(inputs)
	return en_pricing_footer(inputs)
});